import { render, staticRenderFns } from "./IconSlider.vue?vue&type=template&id=149fe064&functional=true&"
import script from "./IconSlider.vue?vue&type=script&lang=js&"
export * from "./IconSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports